import { useTranslation } from "react-i18next";
import type { PlatformTypeName } from "@multi-chat/shared";
import { channelLabelI18nKey } from "../../../components/channel/channel-presentation.js";
import { ConversationAvatar } from "../ConversationAvatar/ConversationAvatar.js";

/** Top of the timeline once the oldest page is loaded; never shown while older history remains. */
export function ConversationStartMarker({
  title,
  imageUrl,
  platformType,
  toneSeed,
}: {
  title: string;
  imageUrl: string | null;
  platformType: PlatformTypeName;
  toneSeed: number;
}): React.JSX.Element {
  const { t } = useTranslation();
  const channel = t(`channel.${channelLabelI18nKey(platformType)}`);

  return (
    <li
      className="flex flex-col items-center gap-1.5 pt-[18px] pb-[26px] text-center text-[0.78125rem] text-inbox-muted"
      data-testid="conversation-start-marker"
    >
      <ConversationAvatar
        title={title}
        imageUrl={imageUrl}
        platformType={platformType}
        toneSeed={toneSeed}
        size="sm"
      />
      <p className="m-0 mt-1 max-w-full truncate text-[0.84375rem] font-semibold text-inbox-strong" dir="auto">
        {t("inbox.thread.startOf", { name: `\u2068${title}\u2069` })}
      </p>
      <p className="m-0 flex w-full max-w-[360px] items-center gap-2.5 text-[0.71875rem] text-inbox-subtle before:h-px before:flex-1 before:bg-inbox-line after:h-px after:flex-1 after:bg-inbox-line">
        {t("inbox.thread.startVia", { channel })}
      </p>
    </li>
  );
}
